import Axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { baseApiRoute } from 'src/resources/const';

export type Headers = { [key: string]: string };

interface ApplicationHeaders extends Headers {
  'Content-Type': string;
}

const headers: ApplicationHeaders = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
};

let config: AxiosRequestConfig = {
  baseURL: baseApiRoute,
  headers: headers
};

const HttpClient: AxiosInstance = Axios.create(config);

export default HttpClient;


// WEBPACK FOOTER //
// ./src/services/api-client/resource/base/HttpClient.tsx